<template>
  <div>
    <!-- 列表页面 -->
    <div class="container" v-if="!showEdit">
      <sticky-top>
        <div class="header">
          <div class="title">消息列表            
            <el-button type="text" icon="el-icon-setting" circle @click="onSetting"></el-button>
          </div>
          <div class="header-right">
            <el-select v-model="filterShowable" @change="onFilterDisplay" placeholder="选择显示过滤条件" class="margin">
              <el-option
                v-for="item in showOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="filterStatus" @change="onFilterDisplay" placeholder="选择删除过滤条件" class="margin">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <lin-search @query="onQueryChange" ref="searchKeyword" />
            <span class="back" @click="back">
              <i class="iconfont icon-fanhui"></i> 返回
            </span>
          </div>
        </div>
      </sticky-top>
      <!-- 表格 -->
      <lin-table
        ref="table"
        :tableColumn="tableColumn"
        :tableData="tableData"
        :operate="operate"
        @handleOperate="handleOperate"
        v-loading="loading"></lin-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :background="true"
          :page-size="pageCount"
          :current-page="currentPage"
          v-if="refreshPagination"
          layout="prev, pager, next, jumper"
          :total="total_nums">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="设置" :visible.sync="dialogSettingVisible" center :close-on-click-modal="false">
      <el-row>
        <el-col :span="12">
          <el-col :span="6" class="title">
              是否需要审核
          </el-col>
          <el-col :span="6">
              <el-switch v-model="settings.varify"></el-switch>
          </el-col>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSettingVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSettingAccept">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import prjMessage from '../../../models/project_message'
import projectApi from '../../../models/project'
import LinTable from '@/components/base/table/lin-table'
import LinSearch from '@/components/base/search/lin-search'
import TableImage from '../../../../Common/components/TableImage'
import Utils from '../../../../../lin/utils/util'

export default {
  components: {
    LinTable,
    LinSearch,
    TableImage,
  },
  data() {
    return {
      tableColumn: [        
        {
          prop: 'player.head || player.channel_head',
          label: '头像',
          style: {width:"40px",height:"40px"},
          component: TableImage,
        },        
        { prop: 'like', label: '赞'},        
        { prop: 'dislike', label: '踩'},
        { prop: 'player.nickname', label: '昵称' },
        { prop: 'player.name', label: '姓名' },
        { prop: 'player.phone', label: '电话' },
        { prop: 'msg', label: '留言', width: 400},
      ],
      tableData: [],
      operate: [],
      showEdit: false,
      dataID: 1,

      refreshPagination: true, // 页数增加的时候，因为缓存的缘故，需要刷新Pagination组件
      total_nums: 0, // 分组内的总数
      currentPage: 1, // 默认获取第一页的数据
      pageCount: 30, // 每页10条数据
      searchKeyword: '',
      filterByDisplay: false,

      showPreview: false,
      selectedRow: {},

      filterShowable: 0,
      filterStatus: 0,
      showOptions: [{
        label: "所有",
        value: 0,
      },{
        label: "显示",
        value: 1,
      },{
        label: "不显示",
        value: 2,
      }],
      statusOptions: [{
        label: "所有",
        value: 0,
      },{
        label: "未读",
        value: 1,
      },{
        label: "已读",
        value: 2,
      },{
        label: "已删除",
        value: 3,
      }],

      dialogSettingVisible: false,
      settings: {},
    }
  },
  async created() {
    this.loading = true
    this.getDatas()
    this.operate = [
      { name: '精选', operate: 'show', type: 'primary', button: "switch", prop: "show", active: "显示", inactive: "隐藏"},
      { name: '状态', operate: 'status', type: 'primary', button: "select", prop: "status", options: [{label: "未读", value:0},{label: "不删除", value:1}, {label: "删除", value:2}] },
      { name: '删除', operate: 'delete', type: 'primary'},
    ]
    this.loading = false
  },
  methods: {
    onQueryChange(query) {
      // 处理带空格的情况
      this.searchKeyword = query.trim()
      this.getDatas()
    },
    onFilterDisplay(value) {
      this.getDatas()
    },
    async getDatas() {
      try {
        this.loading = true
        const data = await prjMessage.gets({project_id: this.$store.getters.project, count: this.pageCount, page: this.currentPage, q: this.searchKeyword,
                                            f_status: this.filterStatus - 1, f_show: this.filterShowable - 1})
        this.tableData = data.rows
        this.total_nums = data.count
        this.loading = false
      } catch (error) {
        this.loading = false
        if (error.error_code === 10020) {
          this.tableData = []
        }
      }
    },
    async handleOperate(val) {
      if(val.operate == "delete") {
        try {
          const res = await prjMessage.delete(val.row.id)
          if (res.error_code === 0) {
            this.$message.success(`${res.msg}`)
            this.getDatas()
          }
        }catch (error) {
          console.log(error)
          this.$message.error(error)
        }
        return;
      }

      try {
        let data = Utils.deepClone(val.row)
        delete data.player
        delete data.project
        if(val.operate == "show" && data.show) {
          data.status = 1
        }
        const res = await prjMessage.edit(data.id, data)
        if (res.error_code === 0) {
          this.$message.success(`${res.msg}`)
        }
      } catch (error) {
        console.log(error)
        this.$message.error(error)
      }
    },
    // 切换table页
    async handleCurrentChange(val) {
      this.currentPage = val
      this.loading = true
      await this.getDatas()
      this.loading = false
    },
    editClose() {
      this.showEdit = false
      this.getDatas()
    },
    back() {
      this.$emit('editClose')
    },
    async onSetting() {
      this.settings = await projectApi.getFeatureSetting(this.$store.getters.project, "message") || {}
      this.dialogSettingVisible = true
    },
    async onSettingAccept() {
      try {
        let res = await projectApi.setFeatureSetting(this.$store.getters.project, "message", this.settings)
        if(res && res.error_code == 0) {
          this.$message.success(`${res.msg}`)
          this.dialogSettingVisible = false
        }else{
          this.$message.error("提交失败")
        }
      }catch(e) {
        this.$message.error(e)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.container {
  .header {
    padding: 0 30px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      height: 59px;
      line-height: 59px;
      color: $parent-title-color;
      font-size: 16px;
      font-weight: 500;
    }

    .filter-area {
      margin:0 5px;
    }

    .filter-title {
      font-size: 12px;
      margin-right: 5px;
    }
  }

  .header-right {
    float: right;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px;
  }

  .back {
    margin-left: 20px;
    cursor: pointer;
  }

  .margin {
    margin-right: 5px;
  }
}
</style>
